<template>
  <div class="createSemdReBuy">
    <!-- 头部返回 -->
    <div class="backBox">
      <jd-button type="blue" :styleTextObj="{width:'44px',height: '24px','line-height': '24px',padding: '0 8px','min-width': '44px'}" @click="returnBack()">返回</jd-button>
      <span class="backBox_name">{{
        isLook ? "查看" : !valueRow || activityData.isCopy ? "N元锁权" : "编辑"
      }}</span>
    </div>
    <div class="stepBox">
      <el-steps class="bz" :space="300" :active="isActiveStep">
        <el-step title="设置规则"></el-step>
        <el-step title="完成发布"></el-step>
      </el-steps>
    </div>
    <!-- 表单 -->
    <div
      v-if="isActiveStep == 0"
      class="formBox"
      style="height: calc(100% - 285px);"
    >
      <!-- 活动条件表单设置 -->
      <div class="secondstep">
        <el-form
          :model="formData"
          :rules="rules"
          ref="formData"
          class="backgroundForm"
          label-width="175px"
        >
          <jd-title label='基本规则' type="bold"></jd-title>
          <el-form-item label="活动名称：" required>
            <el-input
              v-model="formData.activityName"
              maxlength="15"
              show-word-limit
              placeholder="请输入活动名称"
              style="width: 400px"
              :disabled="isStart"
            ></el-input>
          </el-form-item>
          <el-form-item label="活动参与对象：" required prop="partner">
            <el-checkbox-group
              v-model="formData.partner"
              @change="checkListchange"
              :disabled="isStart"
            >
              <el-checkbox label="-1" name="partner">全部</el-checkbox>
              <el-checkbox
                label="0"
                name="partner"
                :disabled="formData.partner == -1"
                >非会员</el-checkbox
              >
              <template v-if="!!levelList && levelList.length >= 0">
                <el-checkbox
                  v-for="(item, index) in levelList"
                  :key="index"
                  :label="index + 1 + ''"
                  :disabled="formData.partner == -1"
                  name="partner"
                  >{{ item }}
                </el-checkbox>
              </template>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="活动起止时间：" required>
            <el-date-picker
              v-model="formData.activeStartTime"
              placeholder="开始时间"
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              ref="timeBox"
              style="width: 200px; font-size: 12px"
              :picker-options="payStartTimeOption"
              :default-time="defaultStartTime"
              @change="(val) => (formData.activeStartTime = val)"
              :disabled="isStart"
            >
            </el-date-picker>
            至
            <el-date-picker
              v-model="formData.activeEndTime"
              type="datetime"
              placeholder="结束时间"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              ref="timeBox"
              style="width: 200px; font-size: 12px"
              :picker-options="payEndTimeOption"
              :default-time="defaultEndTime"
              :disabled="isStart"
              @change="(val) => handlePayEndTime(val)"
            >
            </el-date-picker>
            <div>
              <span style="color: red">注：活动时间需被令牌有效时间覆盖</span>
            </div>
          </el-form-item>
          <!-- 下单预定规则 -->
          <jd-title label='预定规则' type="bold"></jd-title>
          <el-form-item label="付款时间：" required>
            <el-date-picker
              v-model="formData.payStartTime"
              type="datetime"
              placeholder="开始时间"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              ref="timeBox"
              style="width: 200px; font-size: 12px"
              :picker-options="payStartTimeOption"
              :default-time="defaultStartTime"
              @change="(val) => (formData.payStartTime = val)"
              :disabled="isStart"
            >
            </el-date-picker>
            至
            <el-date-picker
              v-model="formData.payEndTime"
              type="datetime"
              placeholder="结束时间"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              ref="timeBox"
              style="width: 200px; font-size: 12px"
              :picker-options="payEndTimeOption"
              :default-time="defaultEndTime"
              :disabled="isStart"
              @change="(val) => handlePayEndTime(val)"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="预定商品：" required>
            <div class="item-wrap">
              <el-radio
                v-model="formData.sampleProductsType"
                @change="handleProductsType"
                :label="0"
                :disabled="isStart"
              >
                全部商品
              </el-radio>
              <el-radio
                v-model="formData.sampleProductsType"
                @change="handleProductsType"
                :label="1"
                :disabled="isStart"
              >
                指定商品
                <template v-if="formData.sampleProductsType == 1">
                  {{ "(已选" + formData.sampleProductList.length + "个)" }}
                </template>
              </el-radio>
              <template v-if="formData.sampleProductsType == 1">
                <span style="margin-right: 10px">
                  <!-- 查看-商品按钮不禁用 -->
                  <el-form :model="formData" label-width="150px">
                    <el-button
                      style=""
                      type="returnBtn"
                      @click="isShowSelectGoods = true"
                      >选择商品</el-button
                    >
                  </el-form>
                </span>
              </template>
              <el-radio
                v-model="formData.sampleProductsType"
                @change="handleProductsType"
                :label="2"
                :disabled="isStart"
              >
                排除商品
                <template v-if="formData.sampleProductsType == 2">
                  {{ "(已选" + formData.sampleProductList.length + "个)" }}
                </template>
              </el-radio>
              <template v-if="formData.sampleProductsType == 2">
                <span style="margin-right: 10px">
                  <!-- 查看-商品按钮不禁用 -->
                  <el-form :model="formData" label-width="150px">
                    <el-button
                      style=""
                      type="returnBtn"
                      class="zindexBox"
                      @click="isShowSelectGoods = true"
                      >选择商品</el-button
                    >
                  </el-form>
                </span>
              </template>
            </div>
            <div class="red">注：订单中指定的商品金额为0会默认剔除</div>
          </el-form-item>
          <el-form-item label-width="165px">
            <template #label>
              <div>
                <span>排除影分身</span>
                <el-tooltip
                    effect="light"
                    content="根据配置的主SKU有对标的影分身名称则剔除，如果没有则按主SKU判断"
                    placement="bottom"
                  >
                    <span class="question-style1">
                      <i class="el-icon-question"></i>
                      <span class="icon-style">:</span>
                    </span>
                </el-tooltip>
              </div>
            </template>
            <jd-table
                :tableData="formData.excludeShadowSkuVOList"
                style="width: 700px;"
              >
                <el-table-column label="主SKU">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.mainSkuId" placeholder="请输入" @input="scope.row.mainSkuId = handleMainSkuId($event)">
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column>
                  <template slot="header">
                    <span>影分身SKU</span>
                    <el-tooltip
                        class="item"
                        effect="light"
                        content="影分身SKU用于核销校验主SKU+影分身标题"
                        placement="bottom"
                      >
                        <span class="question-style">
                          <i class="el-icon-question"></i>
                        </span>
                    </el-tooltip>
                  </template>
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.shadowSkuId" placeholder="请输入" @input="scope.row.shadowSkuId = handleShadowSkuId($event)">
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column label="操作"> 
                  <template slot-scope="scope">
                    <jd-button type="blueText" @click="handleDeleteSKU(scope)">删除</jd-button>
                  </template>
                </el-table-column>
              </jd-table>
              <jd-button type="blueText" @click="addSKU">+添加</jd-button>
          </el-form-item>
          <el-form-item label="商品件数：" required>
            <el-input
              type="text"
              placeholder="请输入"
              v-model="formData.itemTotal"
              maxlength="6"
              clearable
              style="width: 200px"
              @input="(val) => checkputn(val, 'itemTotal')"
              :disabled="isStart"
            ></el-input>
            件
            <span class="red"
              >注：填入数值则用户下单预定商品的件数需≥该数值</span
            >
          </el-form-item>
          <el-form-item label="确认收货时间：" required>
            <el-date-picker
              v-model="formData.finishStartTime"
              disabled
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              ref="timeBox"
              style="width: 200px; font-size: 12px"
              :default-time="defaultStartTime"
              placeholder="预定付款开始时间"
            >
            </el-date-picker>
            至
            <el-date-picker
              v-model="formData.finishEndTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              ref="timeBox"
              style="width: 200px; font-size: 12px"
              :picker-options="finishEndTimeOption"
              :default-time="defaultEndTime"
              :disabled="isStart"
              @change="(val) => handleFinishTime(val)"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="确认收货n天后可参与：">
            确认收货后
            <el-input
              type="text"
              placeholder="请输入0-7之间的数字"
              :maxlength="6"
              v-model="formData.dayTotal"
              clearable
              style="width: 200px"
              @input="(val) => checkputn(val, 'dayTotal')"
              :disabled="isStart"
            ></el-input>
            天
            <div>
              <span style="color: red"
                >注：不填代表预定商品订单符合确认收货时间条件即可，用户一确认收货就发放令牌（赠品）</span
              >
            </div>
          </el-form-item>
          <!-- 奖品设置 -->
          <jd-title label='奖品设置' type="bold"></jd-title>
          <el-form-item label="添加令牌：" required>
            <template slot-scope="scope">
              <el-button
                type=""
                style="width: unset"
                @click="selectToken(scope.row)"
                >选择令牌</el-button
              >
            </template>
          </el-form-item>

          <!-- <el-form-item label="令牌名称：" >
            <template slot-scope="scope">
              {{ tokenNames ? tokenNames:'-' }}
            </template>
          </el-form-item> -->

          <el-form-item label="令牌中绑定的促销活动" required>
            <div v-for="(item, index) in focus">
              <div
                style="
                  background-color: rgb(250, 250, 250, 0.5);
                  width: 800px;
                  padding: 15px;
                  margin-top: 10px;
                "
              >
                <div>
                  <span style="color: red">*</span>促销活动时间：{{
                    item.timesOne
                  }}
                  -
                  {{ item.timesTwo }}
                </div>
                <span style="display: inline-block"
                  ><span style="color: red">*</span>促销商品:</span
                >
                <div style="margin-left: 70px; margin-top: -22px">
                  <!-- 商品列表表格 -->
                  <frontPageTable :productList="item.promotiProducts"
                    :headerCellStyle="{'text-align': 'center','border-bottom': '2px solid #EBEEF5',background: '#FAFAFA'}"
                    :cellStyle="{ 'text-align': 'center', overflow: 'visible' }"
                    :tableStyle="'width: 700px; overflow: visible;'"
                    :paginationStyle="'width: 700px; overflow: visible; margin-top: 15px;display: flex;justify-content: end;'">
                    <template #tableContent>
                      <el-table-column label="商品名称" prop="skuName">
                      </el-table-column>
                      <el-table-column label="skuid" prop="skuId">
                      </el-table-column>
                      <el-table-column label="京东价" prop="jdPrice">
                      </el-table-column>
                    </template>
                  </frontPageTable>
                  <!-- <jd-table
                    :tableData="item.promotiProducts"
                    style="width: 700px;"
                  >
                    <el-table-column label="商品名称" prop="skuName">
                    </el-table-column>
                    <el-table-column label="skuid" prop="skuId">
                    </el-table-column>
                    <el-table-column label="京东价" prop="jdPrice">
                    </el-table-column>
                  </jd-table> -->
                </div>
                <div style="margin-top: 15px"></div>
                <span style="display: inline-block"
                  ><span style="color: red">*</span>赠品SKU:</span
                >
                <div style="margin-left: 70px; margin-top: -22px">
                  <frontPageTable :productList="item.promotiProductsOne"
                    :headerCellStyle="{'text-align': 'center','border-bottom': '2px solid #EBEEF5',background: '#FAFAFA'}"
                    :cellStyle="{ 'text-align': 'center', overflow: 'visible' }"
                    :tableStyle="'width: 700px; overflow: visible;'"
                    :paginationStyle="'width: 700px; overflow: visible; margin-top: 15px;display: flex;justify-content: end;'">
                    <template #tableContent>
                      <el-table-column label="商品名称" prop="skuName">
                      </el-table-column>
                      <el-table-column label="主SKU">
                        <template slot-scope="scope">
                          <span>{{ scope.row.skuId  }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column>
                        <template slot="header" slot-scope="scope">
                          <span>影分身SKU</span>
                          <el-tooltip
                            class="item"
                            effect="light"
                            content="影分身SKU用于核销校验主SKU号+影分身标题"
                            placement="bottom">
                            <span class="question-style">
                              <i class="el-icon-question"></i>
                            </span>
                          </el-tooltip>
                        </template>
                        <template slot-scope="scope">
                          <span>{{ scope.row.shadowSkuId }}</span>
                        </template>
                      </el-table-column>
                    </template>
                  </frontPageTable>
                  <!-- <jd-table
                    :tableData="item.promotiProductsOne"
                    style="width: 700px;" >
                    <el-table-column label="商品名称" prop="skuName">
                    </el-table-column>
                    <el-table-column label="主SKU">
                      <template slot-scope="scope">
                        <span>{{ scope.row.skuId  }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column>
                      <template slot="header" slot-scope="scope">
                        <span>影分身SKU</span>
                        <el-tooltip
                          class="item"
                          effect="light"
                          content="影分身SKU用于核销校验主SKU号+影分身标题"
                          placement="bottom"
                        >
                          <span class="question-style">
                            <i class="el-icon-question"></i>
                          </span>
                        </el-tooltip>
                        
                      </template>
                      <template slot-scope="scope">
                        <span>{{ scope.row.shadowSkuId }}</span>
                      </template>
                    </el-table-column>
                  </jd-table> -->
                </div>
              </div>
            </div>
          </el-form-item>

          <jd-title label='参与限制规则' type="bold"></jd-title>
          <el-form-item label="令牌（赠品）限量:" required>
            <div>
              同一活动，令牌（赠品）总数量仅发放
              <!-- maxlength="15" -->
              <el-input
                v-model="formData.prizeLimitNum"
                style="width: 200px"
                maxlength="6"
                @input="(val) => checkputn(val, 'prizeLimitNum')"
                :disabled="isStart"
              ></el-input
              >个
            </div>
            <div style="color: red">
              注：令牌（赠品）总数需小于商家后台设置的促销总数量，当用户符合预定条件时，发放令牌（赠品），此时令牌（赠品）数量减一库存
            </div>
          </el-form-item>
          <el-form-item label="令牌（赠品）限购:">
            <div>同一活动，令牌（赠品）仅核销1次</div>
            <div style="color: red">
              注：用户核销一次令牌（赠品）后，后续即使符合预定规则也不再发放令牌（赠品）
            </div>
          </el-form-item>
          <div style="margin-left: 62px">
            <el-switch
              @change="incompatChange"
              v-model="formData.incompatibilityActivityIdList"
            >
            </el-switch
            >&nbsp;<span>活动互斥:</span>&nbsp;&nbsp;&nbsp;若用户已参与指定活动,则在本次活动不可再重复参与
            <div style="color: red; margin-top: 12px; margin-left: 110px">
              注：用户核销一次令牌（赠品）后，后续即使符合预定规则也不再发放令牌（赠品）
            </div>
            <div style="margin-top: 17px; margin-left: 110px">
              指定活动选择：
              <el-radio-group
                :disabled="disProvinceRadio"
                v-model="formData.provinceRadio"
                @change="handleRadioChange"
              >
                <el-radio label="">全部活动</el-radio>
                <el-radio label="1">部分活动</el-radio>
              </el-radio-group>
              <span
                >&nbsp;
                <el-cascader
                  v-if="formData.provinceRadio == 1"
                  collapse-tags
                  :options="options"
                  multiple
                  style="width: 300px"
                  :props="props"
                  v-model="formData.selectedOptions"
                  placeholder="请选择"
                ></el-cascader>
              </span>
            </div>
          </div>
          <!-- 新增字段 -->
          <el-form-item label="是否重点活动:" required>
            <div class="flexc-cen-x mt10">
              <el-radio-group v-model="isKeyActivity" :disabled="isDisabledNew">
                <el-radio :label="0">否</el-radio>
                <el-radio :label="1">是</el-radio>
              </el-radio-group>
              <el-tooltip class="item" effect="dark" placement="top">
                <template slot="content">
                  <div>
                    大促、品牌高流量等活动建议选「是」，官方会有一定的技术保障资源倾斜
                  </div>
                </template>
                <i class="new-icon-box ml8"></i>
              </el-tooltip>
            </div>
          </el-form-item>
          <el-form-item label="活动投放位置:" required>
            <el-checkbox-group v-model="placementPosition" :disabled="isDisabledNew">
              <el-checkbox label="HOME">京东APP首场曝光位</el-checkbox>
              <el-checkbox label="CHANNEL">大促主会场资源</el-checkbox>
              <el-checkbox label="SEARCH_RECOMMEND">搜索与推荐链路</el-checkbox>
              <el-checkbox label="SHOP">店铺</el-checkbox>
              <el-checkbox label="OUTSIDE">域外曝光</el-checkbox>
              <el-checkbox label="OTHER">其他渠道</el-checkbox>
              <el-tooltip class="item" effect="dark" placement="top">
                <template slot="content">
                  <div>上方选择为【是】时请选择活动投放位置便于官方监控流量</div>
                </template>
                <i class="new-icon-box ml8"></i>
              </el-tooltip>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <template v-if="isActiveStep == 0">
      <div style="margin: 24px;">
        注：令牌核销机制：令牌核销节点为用户下单出现≥1笔即令牌移除（核销），在订单完成状态前有退款，系统自动重发令牌（约3~5分钟发放令牌）
      </div>
      <div class="create_bottom" v-if="!isLook">
        <jd-button @click="saveDraft" v-if="hasDraftBtn">存为草稿</jd-button>
        <jd-button @click="vaildForm" type="blue"
          >保存设置</jd-button
        >
      </div>
    </template>
    <!-- 完成发布 -->
    <el-result
      icon="success"
      title="活动设置完成！"
      subTitle=""
      v-if="isActiveStep == 1"
    >
    </el-result>
    <selectGoodsGift
      v-if="isShowPiontProduct"
      ref="selectPiontProduct"
      :echoDate="echoDate"
      @choose-shop="getTheData"
    >
    </selectGoodsGift>
    <!-- 选择实物 -->
    <!-- 预定 -->
    <select-goods
      ref="selectGoods"
      v-if="isShowSelectGoods"
      :isShow="isShowSelectGoods"
      :isEdit="isEdit"
      :moduleType="true"
      :skuSearch="true"
      :xianz="false"
      :selectGoods="formData.sampleProductList"
      @close="selectGoodsChange"
      :disabled="isLook"
    ></select-goods>
    <!-- 复购 -->
    <select-goods
      ref="selectGoods"
      v-if="isShowReSelectGoods"
      :isShow="isShowReSelectGoods"
      :moduleType="true"
      :skuSearch="true"
      :xianz="false"
      :selectGoods="formData.reProductList"
      @close="selectReGoodsChange"
      :disabled="isLook"
    ></select-goods>

    <!-- 保存并完成设置弹框 -->
    <el-dialog
      title="重要提示"
      v-if="showSetDialog"
      :visible.sync="showSetDialog"
      width="800"
      @close="showSetDialog = false"
    >
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner"
        >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
      >
      <div slot="footer" class="dialog-footer">
        <el-button @click="showSetDialog = false">取 消</el-button>
        <el-button @click="handleDialogCloseAnoth()" type="primary"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <!-- 选择令牌 -->
    <el-dialog
      title="选择令牌"
      :visible.sync="selectTokenDialog"
      width="1200px"
      @close="selectTokenDialog = false"
    >
      <jd-tip style="margin: 0 0 10px 0;">
          提示：商家需手工添加官方申请的令牌，以下填写的信息请务必与官方申请的信息一致，否则会导致活动异常，引起客诉
      </jd-tip>
      <input-form
        ref="inputRef"
        :inputData="inputDataDetail"
        :btnPosition1="true"
        @toParentVal="searchGiftCardDetail"
      ></input-form>
      <el-table
        ref="checkTable"
        row-key="id"
        v-loading="tableDetailLoading"
        :data="giftCardList"
        style="width: 100%"
        @selection-change="handleSelectionChange"
        :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
        :cell-style="{ 'text-align': 'left' }"
      >
        <el-table-column type="selection" reserve-selection></el-table-column>
        <el-table-column label="令牌信息">
          <template slot-scope="scope">
            <div>令牌名称：{{ scope.row.name }}</div>
            <div>令牌ID：{{ scope.row.tokenId }}</div>
            <div>令牌密钥：{{ scope.row.secretKey }}</div>
          </template>
        </el-table-column>
        <el-table-column label="创建时间">
          <template slot-scope="scope">
            <div>{{ scope.row.createTime }}</div>
          </template>
        </el-table-column>
        <el-table-column label="令牌描述">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="light"
              :content="scope.row.description"
              placement="bottom"
            >
              <div class="remark-tip">
                {{ scope.row.description }}
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="令牌有效时间">
          <template slot-scope="scope">
            <span>起：{{ scope.row.startTime }}</span
            ><br />
            <span>止：{{ scope.row.endTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="时效状态">
          <template slot-scope="scope">
            <div>
              {{
                scope.row.status == 1
                  ? "待生效"
                  : scope.row.status == 2
                  ? "已生效"
                  : scope.row.status == 3
                  ? "已结束"
                  : ""
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="促销活动类型" width="180">
          <template #default="{ row }">
            <div v-if="row.promoType == 0">赠品促销</div>
            <div v-else-if="row.promoType == 1">单品促销</div>
            <div v-else-if="row.promoType == 2">套装促销</div>
            <div v-else-if="row.promoType == 3">总价促销</div>
            <div v-else>赠品促销</div>
          </template>
        </el-table-column>
      </el-table>
      <div class="new-pagination-page" style="margin-top: 20px">
        <el-pagination
          background
          @size-change="handleDetailSizeChange"
          @current-change="handleDetailCurrentChange"
          :current-page="formList.current"
          :page-sizes="[10, 30, 50, 100]"
          :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper"
          class="pagination"
          style="text-align: right; margin-top: 10px"
          :total="totalDetail"
        ></el-pagination>
      </div>
      <div slot="footer" class="dialog-footer">
        <jd-button @click="selectTokenDialog = false">取 消</jd-button>
        <jd-button @click="tokenSure()" type="break">确 定</jd-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  promoTokenPage, //令牌分页
  promoTokenDetail, //令牌详情接口
} from "@/api/integralCenter/tokenSummary.js";
import draggable from "vuedraggable";
import richText from "@/components/richText.vue";
import selectGoods from "@/components/selectGoodsMonitor2.vue";
import selectGoodsGift from "./select_goodsGift";
import selectProduct from "./select_product.vue";
import inputForm from "@/components/inputForm";
import { queryActivity } from "@/api/jhk/activityController.js";

import { querymemberLevel } from "@/api/jhk/integralCenter/memberLevel.js";
import {
  getSendReBuyDetail,
  promoSave,
  promoReBuyDetail,
} from "@/api/jhk/integralCenter/PointActivityAnalyticController";
import { getTaobaoItemListSku2 as getTaobaoItemListSku } from "@/api/jhk/analysis/ware-controller";
import frontPageTable from "./components/frontPageTable.vue"
export default {
  components: {
    draggable,
    richText,
    selectProduct,
    selectGoods,
    selectGoodsGift,
    inputForm,
    frontPageTable
  },
  props: {
    // 当前行数据 修改数据时
    valueRow: {
      type: Object,
      default: () => {
        return null;
      },
    },
    // 当前活动数据
    activityData: {
      type: Object,
    },
    // 是否是查看数据
    isLook: {
      type: Boolean,
      default: false,
    },
    // 当前活跃值
    activeValue: {
      type: Number,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isKeyActivity: 0,
      placementPosition: [],
      isActiveStep: 0,
      disProvinceRadio: false,
      focus: [
        {
          timesOne: "",
          timesTwo: "",
          promotiProducts: [], //促销商品列表
          promotiProductsOne: [], //赠品SKU
        },
      ],
      promotiProduct1s: [],
      giftCardList: [],
      promoti: [],
      promotiProducts: [], //促销商品列表
      promotiProductsOne: [], //赠品SKU
      totalDetail: 0,
      formList: {
        current: 1,
        size: 10,
        tokenId: "",
        name: "",
        createStartTime: "",
        createEndTime: "",
        tokenStartTime: "",
        tokenEndTime: "",
        status: "",
      },
      giftCardList: [
        {
          memberNick: "林哥哥",
          prizeName: "蜡笔小新",
          prizeName1: "三丽鸥",
          prizeName2: "名侦探柯南 ba",
          prizeName3: "魔道祖师",
        },
      ],
      tableDetailLoading: false,
      inputDataDetail: [
        {
          name: "令牌名称",
          val: "name",
          placeholder: "请输入",
        },
        {
          name: "令牌ID",
          val: "tokenId",
          placeholder: "请输入",
        },
        {
          name: "令牌有效时间",
          myDate: true,
          val: ["tokenStartTime", "tokenEndTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault: false,
        },
        {
          name: "创建时间",
          myDate: true,
          val: ["createStartTime", "createEndTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault: false,
        },
        {
          name: "时效状态:",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: "" },
            { label: "待生效", id: 1 },
            { label: "已生效", id: 2 },
            { label: "已结束", id: 3 },
          ],
        },
      ],
      selectTokenDialog: false, //令牌
      props: {
        multiple: true, // 开启多选模式
        value: "value", // 指定选项的值为选项对象的 'value' 属性
        label: "label", // 指定选项标签为选项对象的 'label' 属性
      },
      options: [],
      // 用于区分是不是修改数据
      isEdit: false,
      // 默认时间结尾
      defaultStartTime: "00:00:00",
      defaultEndTime: "23:59:59",
      // 活动结束时间规则
      endTimeOption: {
        disabledDate: (time) => {
          // 大于停止参与时间
          return (
            time.getTime() < Date.now() - 24 * 60 * 60 * 1000 + 1 ||
            time.getTime() >
              new Date(this.$store.getters.loginUserInfo.expiredIn).valueOf() ||
            (this.formData.stopJoinTime &&
              time.getTime() < new Date(this.formData.stopJoinTime).valueOf())
          );
        },
      },
      // 停止参与时间规则
      stopTimeOption: {
        disabledDate: (time) => {
          // 小于 活动结束时间
          // 大于 预定付款结束时间、预定收货结束时间、回购付款结束时间、回购收货结束时间
          return (
            time.getTime() < Date.now() - 24 * 60 * 60 * 1000 + 1 ||
            (this.formData.endTime &&
              time.getTime() >= new Date(this.formData.endTime).valueOf()) ||
            (this.formData.payEndTime &&
              time.getTime() <= new Date(this.formData.payEndTime).valueOf()) ||
            (this.formData.finishEndTime &&
              time.getTime() <=
                new Date(this.formData.finishEndTime).valueOf()) ||
            (this.formData.enterEndTime &&
              time.getTime() <=
                new Date(this.formData.enterEndTime).valueOf()) ||
            (this.formData.rePayEndTime &&
              time.getTime() <=
                new Date(this.formData.rePayEndTime).valueOf()) ||
            (this.formData.reFinishEndTime &&
              time.getTime() <=
                new Date(this.formData.reFinishEndTime).valueOf())
          );
        },
      },
      // --- 预定 ---
      // 预定开始时间规则
      payStartTimeOption: {
        // 小于 预定付款结束时间、停止参与时间、确认收货结束、收货信息录入时间
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 24 * 60 * 60 * 1000 + 1 ||
            (this.formData.payEndTime &&
              time.getTime() > new Date(this.formData.payEndTime).valueOf()) ||
            (this.formData.stopJoinTime &&
              time.getTime() >
                new Date(this.formData.stopJoinTime).valueOf()) ||
            (this.formData.finishEndTime &&
              time.getTime() >
                new Date(this.formData.finishEndTime).valueOf()) ||
            (this.formData.enterEndTime &&
              time.getTime() > new Date(this.formData.enterEndTime).valueOf())
          );
        },
      },
      // 预定结束时间规则
      payEndTimeOption: {
        // 大于预定付款开始时间、小于停止参与时间
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 24 * 60 * 60 * 1000 ||
            (this.formData.payStartTime &&
              time.getTime() <
                new Date(this.formData.payStartTime).valueOf()) ||
            (this.formData.stopJoinTime &&
              time.getTime() > new Date(this.formData.stopJoinTime).valueOf())
          );
        },
      },
      // 预定确认收货结束时间规则
      finishEndTimeOption: {
        // 大于预定收货开始、小于预定结束
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 24 * 60 * 60 * 1000 + 1 ||
            (this.formData.finishStartTime &&
              time.getTime() <
                new Date(this.formData.finishStartTime).valueOf()) ||
            (this.formData.stopJoinTime &&
              time.getTime() > new Date(this.formData.stopJoinTime).valueOf())
          );
        },
      },
      // 预定录入信息结束时间规则
      enterEndTimeOption: {
        // 大于预定录入开始、小于停止参与时间
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 24 * 60 * 60 * 1000 + 1 ||
            (this.formData.enterStartTime &&
              time.getTime() <
                new Date(this.formData.enterStartTime).valueOf()) ||
            (this.formData.stopJoinTime &&
              time.getTime() > new Date(this.formData.stopJoinTime).valueOf())
          );
        },
      },

      // --- 回购 ---
      // 回购付款开始时间规则
      rePayStartTimeOption: {
        // 小于回购付款结束、小于停止参与时间
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 24 * 60 * 60 * 1000 + 1 ||
            (this.formData.rePayEndTime &&
              time.getTime() >
                new Date(this.formData.rePayEndTime).valueOf()) ||
            (this.formData.stopJoinTime &&
              time.getTime() > new Date(this.formData.stopJoinTime).valueOf())
          );
        },
      },
      // 回购付款结束时间规则
      rePayEndTimeOption: {
        // 大于回购付款开始、小于停止参与时间
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 24 * 60 * 60 * 1000 + 1 ||
            (this.formData.rePayStartTime &&
              time.getTime() <
                new Date(this.formData.rePayStartTime).valueOf()) ||
            (this.formData.stopJoinTime &&
              time.getTime() > new Date(this.formData.stopJoinTime).valueOf())
          );
        },
      },
      reFinishEndTimeOption: {
        // 大于回购收货开始、小于停止参与时间
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 24 * 60 * 60 * 1000 + 1 ||
            (this.formData.reFinishStartTime &&
              time.getTime() <
                new Date(this.formData.reFinishStartTime).valueOf()) ||
            (this.formData.stopJoinTime &&
              time.getTime() > new Date(this.formData.stopJoinTime).valueOf())
          );
        },
      },

      formData: {
        // --- 基本规则 ---
        activityName: "",
        partner: ["-1"],
        activeStartTime: "", //活动起止时间
        activeEndTime: "", //活动结束时间

        //----下单预定规则-----

        //付款时间
        payStartTime: "",
        payEndTime: "",
        // 预定商品类型
        sampleProductsType: 0,
        sampleProductList: [],
        // 商品件数
        itemTotal: "",
        // 预定收货时间
        finishStartTime: "",
        finishEndTime: "",
        //确认收货n天后可参与
        dayTotal: "",
        provinceRadio: "",
        selectedOptions: [],

        //----奖品设置到时传id-----

        //----参与限制规则-----
        prizeLimitNum: "",
        incompatibilityActivityIdList: true,

        isOpenCard: false,
        condFollow: 0,

        // 回购商品类型
        reProductList: [],
        reProductsType: 0,
        orderAmt: "",
        giveSkuRule: [],
        excludeShadowSkuVOList: []
      },
      // 会员等级列表
      levelList: [],
      isStart: false,
      // 小程序分享照片 重置数据
      sharePic: "",
      explainPicUrl: "",
      // 表单规则
      rules: {
        // 表单规则校验
        activityName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          {
            max: 15,
            message: "长度在 15 个字符以内",
            trigger: "blur",
          },
        ],
        ruleDescription: [
          { required: true, message: "请填写活动规则", trigger: "blur" },
        ],
        partner: [
          {
            type: "array",
            required: true,
            message: "至少选择一个",
            trigger: "change",
          },
        ],
        prizeSet: [
          {
            type: "array",
            required: true,
            message: " ",
            trigger: "change",
          },
        ],
        startTime: [{ required: true, message: "请选择开始时间" }],
        choosePrize: [{ required: true, message: "请选择奖品" }],
        prizeCount: [{ required: true, message: "请输入奖品数量" }],
        prizeSite: [{ required: true, message: " ", trigger: "blur" }],
        information: [{ required: true, message: " " }],
      },
      // 奖品列表
      prizeSettingList: [
        {
          assetsId: null, // 资产项id(计划id优惠卷id商品id)
          prizeType: 3, // 类型 固定为实物
          price: null, // 价格
          title: "", // 商品标题
          totalAmount: null, // 总共奖品数量
          singleAmount: 1, // 单份奖品数量 固定为1
          logo: null, // 自定义商品图片
        },
      ],
      // 是否打开奖品列表的选择商品弹框
      isShowPiontProduct: false,
      // JingdouCount: {
      //   prizeCount: 0,
      // },
      // typeDefault: {
      //   grantType: 5, // 发放类型  传对应的id值
      //   display: 1, // 是否公开  传对应的id值
      //   type: 0, // 不禁用  传对应的id值
      //   noDisabled: [5], // 不禁用  传对应的id值  可不传（全部可选）
      // },
      echoDate: {},
      // itemArr: [],
      // 实物弹框
      isShowSelectGoods: false,
      isShowReSelectGoods: false,
      // 标识活跃商品选项
      actShopType: null,

      // 保存设置提示框
      showSetDialog: false,
      checked: false, //  是否明确活动规则 保存后弹窗内的勾选框
      isCilk: true,
      isDraft: false,
      ids: "",
    };
  },
  computed: {
    //  自营-1 pop-0
    venderType() {
      return this.$store.getters.loginUserInfo.venderType;
    },
    sellerNick() {
      return this.$store.getters.loginUserInfo.sellerNick;
    },
    // 判断是否有草稿箱按钮
    hasDraftBtn() {
      return this.isDraftEdit || !this.valueRow || this.activityData.isCopy;
    },
    isDisabledNew() {
      let flag = true;
      if(!this.valueRow) {
        flag = false
      }
      if(this.valueRow&&this.valueRow.status==5) {
        flag = false
      }
      if(this.activityData&&(this.activityData.isCopy||this.activityData.singleCopy)) {
        flag = false
      }
      if((this.activityData.id==8||this.activityData.id==19||this.activityData.id==50)&&this.activityData.status==5) {
        flag = false
      }
      return flag
    }
  },
  created() {
    // 获取会员等级
    this.getLevel();
    // console.log("当前活跃", this.activityData);
    // 配置当前分享海报
    // TODO: main.js替换海报
    this.sharePic = this.getDefaultSharePic(this.activityData.id);
    this.formData.sharePic = this.sharePic;
    this.formData.explainPicUrl = this.explainPicUrl;
    this.formData.shareTitle = `我分享了一个${this.activityData.name}活动给你，快来看看吧！`;
    this.formData.shareIntroduce = `我在京东有新发现，绝对适合你，速来围观~`;
    this.formData.jumpPicUrl = this.jumpPicUrl;
  },
  mounted() {
    // 获取会员等级
    this.getLevel();
    this.queryActivitys();
    if (this.valueRow) {
      this.isEdit = true;
    } else {
      this.isEdit = false;
    }
    // 设置form表单是否可操作
    this.isStart = this.activityData.isStart
      ? this.activityData.isStart
      : false;
  },
  watch: {
    formData: {
      deep: true,
      immediate: true,
      handler(newVal) {
        // console.log("newVal", newVal);
        // 预定收货开始、预定录入开始 等于 预定付款开始
        // if(newVal.payStartTime){
        this.formData.finishStartTime = newVal.payStartTime;
        this.formData.enterStartTime = newVal.payStartTime;
        // }
        // 回购收货开始 等于 回购付款开始
        // if(newVal.rePayStartTime){
        this.formData.reFinishStartTime = newVal.rePayStartTime;
        // }
        // 参与条件转换
        if (this.formData.isOpenCard) {
          this.formData.condFollow = 1;
        } else {
          this.formData.condFollow = 0;
        }
      },
    },
  },
  methods: {
    addSKU() {
      if(this.formData.excludeShadowSkuVOList.length==20) {
        this.$message.warning("最多添加20个")
        return
      }
      this.formData.excludeShadowSkuVOList.push({
        mainSkuId: "",
        shadowSkuId: ""
      })  
    },
    // SKU删除
    handleDeleteSKU(scope) {
      this.formData.excludeShadowSkuVOList.splice(scope.$index,1)  
    },
    handleMainSkuId(val){
      return val.replace(/[^\d]/g, '');
    },
    handleShadowSkuId(val){
      return val.replace(/[^0-9,]/g, '');
    },
    //活动互斥
    incompatChange(val) {
      if (val) {
        this.disProvinceRadio = false;
      } else {
        this.disProvinceRadio = true;
      }
    },
    //参与限制，获取部分活动
    queryActivitys() {
      let params = {
        size: -1,
        current: 1,
        activityName: "",
        activityType: 43,
        startUpdateTime: null,
        endUpdateTime: null,
        ids: [],
      };
      queryActivity(params).then((res) => {
        let ArrayNum = [];
        res.data.records.forEach((item) => {
          const params = {
            value: item.id,
            label: item.activityName,
          };
          ArrayNum.push(params);
        });

        console.log("55555555");

        this.options = ArrayNum.flat();
        console.log("55555555", this.options);
      });
    },
    //选择令牌
    handleSelectionChange(val) {
      if (val.length > 1) {
        //最多只能选择一个
        this.$refs.checkTable.clearSelection();
        this.$refs.checkTable.toggleRowSelection(val[val.length - 1], true);
      } else {
        this.promoti = val;
      }
    },
    //分页变化事件
    handleDetailSizeChange(val) {
      this.formList.size = val;
      this.getGiftCardDetail();
    },
    handleDetailCurrentChange(val) {
      this.formList.current = val;
      this.getGiftCardDetail();
    },
    searchGiftCardDetail(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.name = val.name;
      this.formList.createStartTime =
        val.createStartTime == null ? "" : val.createStartTime;
      this.formList.createEndTime =
        val.createEndTime == null ? "" : val.createEndTime;
      this.formList.tokenStartTime =
        val.tokenStartTime == null ? "" : val.tokenStartTime;
      this.formList.tokenEndTime =
        val.tokenEndTime == null ? "" : val.tokenEndTime;
      this.formList.tokenId = val.tokenId;
      this.formList.status = val.status;
      this.getGiftCardDetail();
    },
    //选择令牌明细
    async getGiftCardDetail() {
      this.tableDetailLoading = true;
      try {
        const res = await promoTokenPage(this.formList);
        if (res.code == 1) {
          this.tableDetailLoading = false;
          this.giftCardList = res.data.records;
          this.totalDetail = Number(res.data.total);
          const row = this.giftCardList.find(v=> v.id == this.ids)
          if(row){
            this.$nextTick(()=>{
              this.$refs.checkTable.toggleRowSelection(row,true);
            })
          }
        } else {
          this.tableDetailLoading = false;
        }
      } catch (error) {
        this.tableDetailLoading = false;
      }
    },
    //选择令牌
    selectToken(val) {
      this.selectTokenDialog = true;
      this.formList.current = 1;
      this.formList.size = 10;
      this.$nextTick(() => {
        this.$refs.inputRef.formSearch();
      });
    },
    //选择令牌
    tokenSure() {
      let ids = {
        id: this.promoti[0].id,
      };
      this.ids = this.promoti[0].id;
      (this.focus = []),
        promoTokenDetail(ids).then((res) => {
          const { detailList } = res.data;
          if (res.code == 1) {
            detailList.forEach((item, index) => {
              const {
                promoSkuList,
                giveSkuList,
                promoStartTime,
                promoEndTime,
                shadowSkuList
              } = item;
              this.focus.push({
                timesOne: "",
                timesTwo: "",
                promotiProducts: [], //促销商品列表
                promotiProductsOne: [], //赠品SKU
              });
              this.focus[index].promotiProducts = promoSkuList;
              this.focus[index].promotiProductsOne = giveSkuList;
              this.focus[index].timesOne = promoStartTime;
              this.focus[index].timesTwo = promoEndTime;
              this.selectTokenDialog = false;
            });
          } else {
            this.$message.error(res.message);
          }
        });
    },
    handleRadioChange(val) {},
    beAdd(row) {
      if (this.isStart) {
        if (row.totalAmount < row.minNum && row.minNum) {
          row.totalAmount = row.minNum;
          this.$message.warning("为避免客诉，奖品数量不能小于之前哦~");
        }
      }
    },
    // 获取会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          this.levelList = [];
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
          // 获取活动详情
          if (this.activeValue) {
            this.getDetail();
          }
        })
        .catch((res) => {});
    },
    // 获取活动详情
    getDetail() {
      if (this.valueRow) {
        let id = this.valueRow.id;
        promoReBuyDetail(id)
          .then((res) => {
            console.log("getSendReBuyDetail", res);
            let rdata = res.data;
            if (rdata.ruleDto.isIncompatibility == 0) {
              this.disProvinceRadio = true;
            } else {
              this.disProvinceRadio = false;
            }
            // this.formData = rdata;
            // 数据回显
            this.formData.activityName = rdata.activityName;
            this.isKeyActivity = rdata.isKeyActivity || 0;
            this.placementPosition = rdata.placementPosition ? rdata.placementPosition.split(",") : ["SHOP"];
            // 活动参与对象
            if (rdata.allowLevel == "0,1,2,3,4,5") {
              this.formData.partner = ["-1"];
            } else {
              this.formData.partner = rdata.allowLevel.split(",");
            }
            // 参与条件
            if (rdata.condFollow == 1) {
              this.formData.isOpenCard = true;
            } else {
              this.formData.isOpenCard = false;
            }

            //随单发回显

            //活动起止时间
            this.formData.activeStartTime = rdata.startTime;
            this.formData.activeEndTime = rdata.endTime;

            //集合里边
            let rule = rdata.ruleDto;

            // 付款时间
            this.formData.payStartTime = rule.payStartTime;
            this.formData.payEndTime = rule.payEndTime;

            //确认收货结束时间
            this.formData.finishStartTime = rule.finishStartTime;
            this.formData.finishEndTime = rule.finishEndTime;

            //商品件数
            this.formData.itemTotal = rule.itemTotal;

            //确认收货n天后可参与
            this.formData.dayTotal = rule.joinDay;

            //赠品限量
            this.formData.prizeLimitNum = rule.prizeLimitNum;

            //令牌id
            this.ids = rdata.promoTokenId;

            //活动互斥
            this.formData.incompatibilityActivityIdList =
              rule.isIncompatibility == 1 ? true : false;
            this.formData.selectedOptions = rule.incompatibilityActivityIdList;
            this.formData.excludeShadowSkuVOList = rule.excludeShadowSkuVOList || [];
            if (rule.incompatibilityActivityIdList.length > 0) {
              this.formData.provinceRadio = "1";
            } else {
              this.formData.provinceRadio = "";
            }

            //令牌回显
            if(this.ids){
              let promoTokenVORule = rdata.promoTokenVO.detailList;
              this.focus = [];
              promoTokenVORule.forEach((i, index) => {
                this.focus.push({
                  timesOne: i.promoStartTime,
                  timesTwo: i.promoEndTime,
                  promotiProducts: i.promoSkuList,
                  promotiProductsOne: i.giveSkuList
                });
              });
            }
            
            //预定商品
            this.formData.sampleProductsType = rule.skuType;
            let sendSku = rule.skuIds;
            this.formData.sampleProductList = [];
            let sampleProductList = [];
            // 查询对应商品信息
            getTaobaoItemListSku({
              current: 1,
              size: 9999999,
              skuIdStr: sendSku.join(","),
            })
              .then((res) => {
                if (res.code == 1) {
                  sampleProductList = res.data.records;
                  this.formData.sampleProductList = sampleProductList;
                } else {
                  this.$message.error(res.message);
                  this.formData.sampleProductList = [];
                }
              })
              .catch((err) => {
                this.$message.error(err);
                this.formData.sampleProductList = [];
              });

            // this.formData.itemTotal = sendRule.itemTotal;
            // this.formData.finishStartTime = sendRule.finishStartTime;
            // this.formData.finishEndTime = sendRule.finishEndTime;
            // this.formData.enterStartTime = sendRule.enterStartTime;
            // this.formData.enterEndTime = sendRule.enterEndTime;

            // 回购
            let reRule = rule.reBuyRule;
            this.formData.rePayStartTime = reRule.payStartTime;
            this.formData.rePayEndTime = reRule.payEndTime;
            this.formData.reProductsType = reRule.skuType;
            // 商品集合
            this.formData.reProductList = [];
            let reProductList = [];
            let reSku = reRule.skuIds;
            // 查询对应商品信息
            getTaobaoItemListSku({
              current: 1,
              size: 9999999,
              skuIdStr: reSku.join(","),
            })
              .then((res) => {
                if (res.code == 1) {
                  reProductList = res.data.records;
                  this.formData.reProductList = reProductList;
                } else {
                  this.$message.error(res.message);
                  this.formData.reProductList = [];
                }
              })
              .catch((err) => {
                this.$message.error(err);
                this.formData.reProductList = [];
              });

            this.formData.orderAmt = String(reRule.amt);
            this.formData.reFinishStartTime = reRule.finishStartTime;
            this.formData.reFinishEndTime = reRule.finishEndTime;

            // 奖品
            this.prizeSettingList = rdata.pointActivityPrizeDTOList;
          })
          .catch((err) => {
            console.log("获取活动详情", err);
          });
      }
    },
    // 会员等级改变
    checkListchange(val) {
      val.forEach((low) => {
        if (low == -1) {
          this.formData.partner = ["-1"];
        }
      });
    },
    // -------------图片部分开始----------------
    // 上传图片前校验 （不校验尺寸，只校验大小和格式）
    // C端背景图、活动页说明图
    beforeUpload(file) {
      let _this = this;
      let image = new Image();
      let _URL = window.URL || window.webkitURL;
      image.onload = function () {
        const valid = true;
        file.isFlag = valid;
        if (valid) {
        } else {
          _this.$message.info("图片尺寸不符合要求，请重新上传");

          return false;
        }
      };
      image.src = _URL.createObjectURL(file);
      const isLt3M = file.size < 1024 * 300;
      if (!isLt3M) {
        this.$message.info("图片大小不符合要求，请重新上传");
        return false;
      }
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"];
      if (sorts.indexOf(type) < 0) {
        this.$message.info("图片格式不符合要求，请重新上传");
        return false;
      }
    },
    // 小程序分享照片 需要校验尺寸
    async beforeUpload2(file) {
      let _this = this;
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"];

      if (sorts.indexOf(type) < 0) {
        this.$message.info("图片格式不符合要求，请重新上传");
        await Promise.reject();
        return false;
      }
      await this.imgchecked(file, 200, 200);
      const isLt3M = file.size < 1024 * 300;
      if (!isLt3M) {
        this.$message.info("图片大小不符合要求，请重新上传");
        await Promise.reject();
        return false;
      }
    },

    //上传图片前校验   悬浮按钮设置
    async beforeUpload3(file) {
      let _this = this;
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"];

      if (sorts.indexOf(type) < 0) {
        this.$message.info("图片格式不符合要求，请重新上传");
        await Promise.reject();
        return false;
      }
      await this.imgchecked(file, 150, 150);
      console.log(file);
      const isLt3M = file.size < 1024 * 100;
      if (!isLt3M) {
        this.$message.info("图片大小不符合要求，请重新上传");
        await Promise.reject();
        return false;
      }
    },

    //判断尺寸方法 默认200*200
    imgchecked(file, width = 200, height = 200) {
      let _this = this;
      return new Promise((resolve, reject) => {
        let image = new Image();
        let _URL = window.URL || window.webkitURL;
        image.onload = function () {
          const valid = image.width == width && image.height == height;
          file.isFlag = valid;
          if (valid) {
            resolve();
          } else {
            _this.$message.info("图片尺寸不符合要求，请重新上传");
            reject();
          }
        };
        image.src = _URL.createObjectURL(file);
      });
    },
    // C端背景图 - 上传成功回调
    handleUpload(res) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        this.formData.picUrl = res.data;
      }
    },
    // 小程序分享图片 - 上传成功回调
    handleUpload1(res) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        this.formData.sharePic = res.data;
      }
    },
    // 活动页说明图 - 上传成功回调
    handleUpload2(res) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        this.formData.explainPicUrl = res.data;
      }
    },
    // 上传成功  悬浮按钮设置
    handleUpload3(res) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        this.formData.jumpPicUrl = res.data;
      }
    },

    // 重置图片  悬浮按钮设置
    picUrlReset3() {
      if (this.activityData.isStart) return;
      this.formData.jumpPicUrl = this.jumpPicUrl;
    },

    // 小程序分享图片重置
    picUrlReset1() {
      if (this.isStart) return;
      this.formData.sharePic = this.sharePic;
    },
    // -------------图片部分结束----------------
    // 预定商品监听
    handleProductsType() {
      if (this.isStart) return;
      this.formData.sampleProductList = [];
    },
    //输入框限制负数
    checkputn(value, key) {
      let filtered = value.replace(/[^0-9]/g, "");
      if (filtered > 7 && key == "dayTotal") {
        filtered = 7;
      }
      if (filtered == 0 && key == "itemTotal") {
        filtered = "";
      }
      this.formData[key] = filtered;
      return filtered;
    },
    handelInput(dataName) {
      let inputValue = this.formData[`${dataName}`];

      // 除数字和小数点之外
      inputValue = inputValue.replace(/^\d[0,9]\.[0-9]{2}?$/, "");

      // 限制小数点后两位
      const parts = inputValue.split(".");
      if (parts[0].length > 1 && parts[0].charAt(0) == "0") {
        parts[0] = parts[0].substring(1);
      }
      if (parts.length > 1) {
        parts[1] = parts[1].slice(0, 2);
        inputValue = parts[0] + "." + parts[1];
      } else {
        inputValue = parts[0];
      }
      let value = isNaN(inputValue) ? "" : inputValue.toString();
      // 更新数据
      if (inputValue < 999999) {
        this.formData[`${dataName}`] = value;
      } else {
        this.formData[`${dataName}`] = "999999";
        this.$message.warning("不能大于999999");
      }
    },
    // handleInput2(valueName) {
    //   let inputValue = this.formData[`${dataName}`];
    //   inputValue = inputValue.replace(/[^\d.]/g, '');
    //   inputValue = inputValue.replace(/^\./, '');
    //   inputValue = inputValue.replace(/\.{2,}/g, '.');

    //   // 限制小数位数为两位
    //   const parts = inputValue.split(".");
    //   if (parts[0].length > 1 && parts[0].charAt(0) == "0") {
    //     parts[0] = parts[0].substring(1);
    //   }
    //   if (parts.length > 1) {
    //     parts[1] = parts[1].slice(0, 2);
    //     inputValue = parts[0] + "." + parts[1];
    //   } else {
    //     inputValue = parts[0];
    //   }

    //   // 限制为大于等于0的正整数
    //   if (inputValue.charAt(0) === '.' || inputValue.charAt(0) === '0') {
    //     inputValue = inputValue.replace(/^0+/, '');
    //   }
    //   let value = isNaN(inputValue) ? "" : inputValue.toString();
    //   // 更新数据
    //   this.formData[`${dataName}`] = value;
    // },
    // 回购商品监听
    handleReProductsType() {
      if (this.isStart) return;
      // 如果选了全部商品，就清空集合
      this.formData.reProductList = [];
    },
    // 获取奖品
    getTheData(data, prizeType) {
      console.log(data, prizeType, "data");
      this.isShowPiontProduct = false;
      this.prizeSettingList[0].assetsId = data.skuId;
      // 奖品类型
      this.prizeSettingList[0].prizeType = prizeType;
      this.prizeSettingList[0].price = Number(data.discount);
      this.prizeSettingList[0].title = data.name;
      this.prizeSettingList[0].logo = data.logo;
    },
    // 奖品表格选择
    centerVis(row) {
      // 无操作权限则返回
      if (this.isStart) return;
      // this.itemArr = this.prizeSettingList;
      this.echoDate = row;
      // this.JingdouCount.prizeCount = row.prizeCount;
      this.isShowPiontProduct = true;
      this.$refs.selectPiontProduct.openDialog();
    },
    colseDialog() {
      this.isShowPiontProduct = false;
      this.clickActual = false;
    },
    // 生成规则
    generateRule() {
      // if(this.venderType == 0) {
      // POP
      this.createPopRule();
      // }else if(this.venderType == 1) {
      // 自营
      // }else {
      // this.$message.error("未登录，无法判断店铺类型");
      // }
    },
    createPopRule() {
      // 店铺名称
      let sellerNickName = this.sellerNick;
      let completeRules = "";
      // 顶部时间，活动奖品，如何参与活动、如何获奖
      let textObj = "",
        eventPrizesText = "",
        addActiveText = "",
        awardsText = "",
        noteText = "";
      // ------顶部时间----开始
      let text1 = "",
        text2 = "",
        text3 = "",
        text4 = "",
        text5 = "",
        text6 = "";
      if (!!this.formData.payStartTime && !!this.formData.payEndTime) {
        text1 = this.formData.payStartTime + " ~ " + this.formData.payEndTime;
      }
      if (!!this.formData.finishStartTime && !!this.formData.finishEndTime) {
        text2 =
          this.formData.finishStartTime + " ~ " + this.formData.finishEndTime;
      }
      if (!!this.formData.rePayStartTime && !!this.formData.rePayEndTime) {
        text3 =
          this.formData.rePayStartTime + " ~ " + this.formData.rePayEndTime;
      }
      if (
        !!this.formData.reFinishStartTime &&
        !!this.formData.reFinishEndTime
      ) {
        text4 =
          this.formData.reFinishStartTime +
          " ~ " +
          this.formData.reFinishEndTime;
      }
      if (!!this.formData.enterStartTime && !!this.formData.enterEndTime) {
        text5 =
          this.formData.enterStartTime + " ~ " + this.formData.enterEndTime;
      }
      if (!!this.formData.endTime) {
        text6 = this.formData.endTime;
      }
      textObj = `<p>活动时间（以北京时间为准）</p><p>尝鲜礼付款时间：${text1}</p><p>尝鲜礼确认收货时间：${text2}</p><p>正装回购付款时间：${text3}</p><p>正装回购确认收货时间：${text4}</p><p>填写收货信息时间：${text5}</p><p>活动页面关闭时间：${text6}</p>
        `;

      // ------活动奖品----开始
      let priceItem = this.prizeSettingList[0];
      let result = "";
      if (!!priceItem.title) {
        result = priceItem.title;
      }
      // 奖品数量
      let totalAmount = !!priceItem.totalAmount ? priceItem.totalAmount : " ";
      eventPrizesText = `<p>一、【活动奖品】</p><p>活动奖品：${result}，<strong style="color:red;">限量${totalAmount}份</strong>。</p><p>*活动期间，<strong style="color:red;">奖品同一用户限量1份（即购买多件指定尝鲜礼或回购多件指定正装，奖品限发1份）</strong>，奖品数量有限，先到先得，送完即止。</p>`;

      // ------如何参与活动----开始
      let orderAmt = !!this.formData.orderAmt ? this.formData.orderAmt : " ";
      addActiveText = `<p>二、【如何参与活动】</p><p>1.用户须为京东【${sellerNickName}】的会员，并在整个活动时间内未操作退出会员。</p><p>2.会员于尝鲜礼付款阶段，在京东【${sellerNickName}】进行指定尝鲜礼付款，并预填收货地址。<strong style="color:red;">尝鲜礼库存有限，卖完恢复日常价，活动期间每个尝鲜礼每IP/UDID/账号限购1单且每单限购1个，</strong>且购买多件尝鲜礼，活动奖品限发1份。</p><p>注：尝鲜礼付款商品范围详见#指定活动商品#</p><p>3.会员完成尝鲜礼付款和收货信息填写后于正装回购付款阶段（预售订单的正装回购付款时间以尾款付款时间为准），在京东【${sellerNickName}】进行指定正装产品付款，且单笔订单金额达到${orderAmt}元（金额不含退款）。</p><p>注：回购付款商品范围详见 #指定活动商品#</p><p>4.用户在规定的确认收货时间内<strong style="color:red;">完成尝鲜礼订单和回购正装订单的收货且已填写收货信息，即完成活动参与，</strong>如经审查符合参与条件且在前${totalAmount}名内，即可锁定奖品等待发奖。奖品数量有限，先到先得，送完即止。</p>`;

      // ------如何获奖----开始
      awardsText = `<p>三、【如何获奖】</p><p>1.用户需在指定的确认收货时间内完成尝鲜礼订单和回购正装订单的收货，在指定填写收货信息时间内完成收货信息的录入。</p><p>2.尝鲜礼订单付款成功后将会提示预填收货信息，<strong style="color:red;">信息一经提交仅支持修改一次，</strong>后续无法修改。订单满足活动要求的用户，<strong style="color:red;">奖品将于填写收货信息时间结束后30个工作日内，按照用户提供的收货信息通过快递形式发出</strong>（如遇疫情等不可抗因素，将相应延迟发放）。1）如果没有提前预填收货信息，可在活动主页【活动记录-收货信息】位置填写相关信息，且须于填写收货信息截止时间前完成填写，逾期视为放弃领奖资格。2）如果收货信息填写错误，须于填写收货信息截止时间前完成修改，若因逾期未改或最终地址依然有误而导致无法发货或无法送达，视为放弃领奖资格，商家无法支持补发。</p><p>3.用户<strong style="color:red;">在活动期间不可操作退出京东【${sellerNickName}】的会员身份，</strong>若中途退出则失去获奖资格，再次入会也无法恢复资格。</p><p>4.如成功参与活动的<strong style="color:red;">用户对商品订单进行退款处理，导致实际确认收货商品或金额不足活动条件，视为用户不符合兑换奖品资格，商家有权取消该用户获取奖品的资格。</strong>同一用户多个订单满足活动要求，也仅可获得1份奖品。同一用户的定义详见注意事项。</p><p>5.由于活动奖品数量有限，系统根据用户活动期内符合要求的首笔已确认收货的尝鲜礼订单的确认收货时间及首笔已确认收货的指定回购正装订单的确认收货时间的后一时间为准选取前${totalAmount}名，如果最后一份奖品排序时间出现同一时间点内有多个用户满足发奖要求，则会采取系统随机的方式进行抽取。</p>`;

      // -----注意事项----开始---
      noteText = `<p>四、【注意事项】</p><p>1.同一用户仅限参与活动一次。同一用户是指账户、手机号码、收件地址、支付账号、身份证号码、设备标识符、注册信息、网络操作日志、交易订单信息等与用户身份和行为相关的信息，其中任意一项或数项存在相同、相似，亦或通过特定标记批量信息进行分析，其数项存在相同、相似的（包括但不限于批量相同、雷同、邻近、虚构的地址）均视为同一用户。同一用户注册、持有、使用或控制多个会员账号，商家有权取消/限制其参与本活动或领取奖品的资格。</p><p>2.活动期间，若发现用户使用或曾使用不正当方式（包括但不限于批量注册，恶意套现，虚假分享，虚假交易，网络攻击，众包作弊，通过任何外挂软件破坏、规避活动规则）或仅以套取活动利益为目的参与本次活动，不符合活动公平、诚信原则的，商家有权直接取消或限制用户参与活动的资格；若用户已领取奖品奖励，商家有权追回（包括但不限于取消违反规则而形成的订单、奖励）；出现前述情形之一的，商家有权将视情况终止、限制用户后续参与商家任意活动的资格，并保留追究其法律责任的权利。</p><p>3.活动期间，如出现不可抗力或形势变更的情况，包括但不限于重大灾害事件、黑客攻击、系统故障、活动受政府机关指令需停止举办或调整本活动的，商家可依据相关法律法规的规定调整或暂停或提前终止活动。</p><p>4. 本活动所发放的所有奖品不可折现、不可转赠他人、不可为他人付款、不支持开具发票。</p><p>5. 实物奖品一经发出，无质量问题恕不退换，如有疑问，请咨询店铺客服。</p><p>6.商家可根据活动的实际进行情况，在法律允许的范围内，对本活动规则进行调整或变动，相关调整或变动将公布在活动规则页上。</p><p>7.如对本活动有任何疑问，请咨询在线客服。</p>`;
      completeRules =
        textObj +
        "<br/>" +
        eventPrizesText +
        "<br/>" +
        addActiveText +
        "<br/>" +
        awardsText +
        "<br/>" +
        noteText;
      this.formData.ruleDescription = completeRules;
    },
    // 保存设置
    vaildForm() {
      // 活动名称
      if (!this.formData.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      // 活动参与对象
      if (this.formData.partner.length <= 0) {
        this.$message.warning("请选择活动参与对象");
        return;
      }
      // 下单预定
      if (!this.formData.payStartTime || !this.formData.payEndTime) {
        this.$message.warning("请补充下单预定付款时间");
        return;
      }
      if (
        this.formData.sampleProductsType == 1 &&
        this.formData.sampleProductList.length <= 0
      ) {
        this.$message.warning("请添加预定商品");
        return;
      }
      let flag =false
      let flag1 =false
      if (
        this.formData.excludeShadowSkuVOList.length > 0
      ) {
        this.formData.excludeShadowSkuVOList.some((item)=>{
          if(!item.mainSkuId) {
            flag = true
          }
          if(!item.shadowSkuId) {
            flag1 = true
          }
        })
        if(flag) {
          this.$message.warning("请输入主SKU");
          return;
        }
        if(flag1) {
          this.$message.warning("请输入影分身SKU");
          return;
        }
      }

      if (
        this.formData.sampleProductsType == 2 &&
        this.formData.sampleProductList.length <= 0
      ) {
        this.$message.warning("请添加预定商品");
        return;
      }

      if (!this.formData.itemTotal) {
        this.$message.warning("请输入商品件数");
        return;
      }
      if (
        this.formData.reProductsType == 1 &&
        this.formData.reProductList.length <= 0
      ) {
        this.$message.warning("请选择回购活动商品");
        return;
      }
      if (this.ids == "") {
        this.$message.warning("请添加令牌");
        return;
      }

      if (
        this.formData.reProductsType == 2 &&
        this.formData.reProductList.length <= 0
      ) {
        this.$message.warning("请选择回购活动商品");
        return;
      }
      if(this.placementPosition.length==0) {
        this.$message.warning("请选择活动投放位置");
        return;
      }
      // 打开提示框
      this.showSetDialog = true;
    },
    // 保存草稿
    saveDraft() {
      //活动名称的限制
      if (!this.formData.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      if (this.isDraftEdit) {
        this.$confirm("是否保存对当前草稿的修改?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      } else {
        this.$confirm("是否存为草稿?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      }
    },
    handleDialogCloseAnoth() {
      console.log("564564654");

      if (this.checked || this.isDraft) {
        console.log("564564654", "========================>", this.formData);
        // 发送请求关闭弹框
        let sendSkuArr = [];
        this.formData.sampleProductList.forEach((item) => {
          sendSkuArr.push(item.skuId);
        });
        let reSkuArr = [];
        this.formData.reProductList.forEach((item) => {
          reSkuArr.push(item.skuId);
        });
        let sendSkuId = sendSkuArr;
        let reSkuId = reSkuArr;
        let allowLevel = null;
        let arr = this.formData.partner;
        allowLevel = this.formData.partner.join(",");
        // arr.forEach((item) => {
        //   if (item == "-1") {
        //     allowLevel = "1,2,3,4,5";
        //   }
        // });
        var fors = [];
        this.formData.selectedOptions.forEach((e) => {
          if (e instanceof Array) {
            e.forEach((val) => {
              fors.push(val);
            });
          } else {
            fors.push(e);
          }
        });
        // 发送请求提交表单
        // 请求参数处理
        let params = {
          // 空为创建
          pointActivityId: this.isEdit ? this.valueRow.id : "",
          promoTokenId: this.ids, //令牌主健ID
          activityName: this.formData.activityName,
          allowLevel: allowLevel,
          condFollow: this.formData.condFollow,
          startTime: this.formData.activeStartTime,
          endTime: this.formData.activeEndTime,
          // 规则
          ruleDTO: {
            //下单预定
            payStartTime: this.formData.payStartTime,
            payEndTime: this.formData.payEndTime,
            skuType: this.formData.sampleProductsType,
            skuIds: sendSkuId,
            itemTotal: this.formData.itemTotal,
            finishStartTime: this.formData.finishStartTime,
            finishEndTime: this.formData.finishEndTime,
            joinDay: this.formData.dayTotal,
            prizeLimitNum: this.formData.prizeLimitNum,
            isIncompatibility:
              this.formData.incompatibilityActivityIdList == true ? "1" : "0",
            incompatibilityActivityIdList:
              this.formData.provinceRadio == 1 ? fors : [],
            excludeShadowSkuVOList: this.formData.excludeShadowSkuVOList
          },
          isKeyActivity: this.isKeyActivity,
          placementPosition: this.placementPosition.join(","),
        };
        if (this.isCilk) {
          this.isCilk = false;
          if (this.isDraft) {
            params.status = 5;
          }
          console.log(this.activityData.isCopy, "-------------------------");

          if (this.activityData.isCopy) {
            params.pointActivityId = "";
          }
          console.log(this.isDraftEdit, "99999");

          // 草稿箱编辑-添加活动id
          if (this.isDraftEdit) {
            params.id = this.valueRow.id;
            delete params.pointActivityId;
          }
          if(this.activityData.isCopy){
            delete params.id
          }
          params.subType = 43;
          promoSave(params)
            .then((res) => {
              if (res.code == 1) {
                if (this.isDraft) {
                  this.$router.push({name:"activityManagement",query:{isDarft:true,activityType:43}})
                } else {
                  this.showSetDialog = false;
                  this.isCilk = true;
                  // this.$router.push({
                  //   name: "throw",
                  //   query: {
                  //     id: res.data.id,
                  //     activityType: res.data.activityType,
                  //     isEdit: false,
                  //   },
                  // });
                  // this.$router.go(0);
                }
                this.$message.success("保存成功！");
                this.isActiveStep = 1;
                // this.$router.go(0);
              } else {
                this.$message.error(res.message);
                this.isCilk = true;
              }
            })
            .catch((err) => {
              console.log("saveActivity报错", err);
              this.isCilk = true;
            });
        }
      } else {
        this.$message.error("请勾选明确活动规则后即可创建");
      }
    },
    // 选择商品回显
    selectGoodsChange(data) {
      console.log(data);
      if (data) {
        this.formData.sampleProductList = data;
      }
      this.isShowSelectGoods = false;
    },
    // 选择商品回显
    selectReGoodsChange(data) {
      if (data) {
        this.formData.reProductList = data;
      }
      this.isShowReSelectGoods = false;
    },
    // 返回上一步
    returnBack() {
      if (this.valueRow && this.valueRow.id) {
        this.$emit("returnBack" , 1);
        return;
      }
      this.$emit("returnBack");
    },
    // 停止参与时间
    handleStopJoinTIme(val) {
      this.formData.stopJoinTime = val;
      if (!!this.formData.endTime) {
        if (
          new Date(this.formData.stopJoinTime) >=
          new Date(this.formData.endTime)
        ) {
          this.$message.error("不能大于等于活动结束时间");
          this.formData.stopJoinTime = "";
        }
      } else if (!!this.formData.endpayEndTimeTime) {
        if (
          new Date(this.formData.stopJoinTime) <=
          new Date(this.formData.payEndTime)
        ) {
          this.$message.error("不能小于等于预定付款结束时间");
          this.formData.stopJoinTime = "";
        }
      } else if (!!this.formData.finishEndTime) {
        if (
          new Date(this.formData.stopJoinTime) <=
          new Date(this.formData.finishEndTime)
        ) {
          this.$message.error("不能小于等于预定确认收货结束时间");
          this.formData.stopJoinTime = "";
        }
      } else if (!!this.formData.enterEndTime) {
        if (
          new Date(this.formData.stopJoinTime) <=
          new Date(this.formData.enterEndTime)
        ) {
          this.$message.error("不能小于等于预定收货信息录入结束时间");
          this.formData.stopJoinTime = "";
        }
      } else if (!!this.formData.rePayEndTime) {
        if (
          new Date(this.formData.stopJoinTime) <=
          new Date(this.formData.rePayEndTime)
        ) {
          this.$message.error("不能小于等于回购付款结束时间");
          this.formData.stopJoinTime = "";
        }
      } else if (!!this.formData.reFinishEndTime) {
        if (
          new Date(this.formData.stopJoinTime) <=
          new Date(this.formData.reFinishEndTime)
        ) {
          this.$message.error("不能小于等于回购确认收货结束时间");
          this.formData.stopJoinTime = "";
        }
      }
    },
    // 预定付款结束限制
    handlePayEndTime(val) {
      // this.formData.payEndTime = val;
      // console.log(this.formData.rePayEndTime, this.formData.stopJoinTime);
      if (!!this.formData.stopJoinTime) {
        if (
          new Date(this.formData.payEndTime) >=
          new Date(this.formData.stopJoinTime)
        ) {
          this.$message.error("不能大于等于停止参与时间");
          this.formData.payEndTime = "";
        }
      }
    },
    handleFinishTime(val) {
      if (!!this.formData.stopJoinTime) {
        if (
          new Date(this.formData.finishEndTime) >=
          new Date(this.formData.stopJoinTime)
        ) {
          this.$message.error("不能大于等于停止参与时间");
          this.formData.finishEndTime = "";
        }
      }
    },
    // 预定付款结束限制
    handleRePayEndTime(val) {
      // this.formData.rePayEndTime = val;
      if (!!this.formData.stopJoinTime) {
        if (
          new Date(this.formData.rePayEndTime) >=
          new Date(this.formData.stopJoinTime)
        ) {
          this.$message.error("不能大于等于停止参与时间");
          this.formData.rePayEndTime = "";
        }
      }
    },
    handleEnterTime(val) {
      if (!!this.formData.stopJoinTime) {
        if (
          new Date(this.formData.enterEndTime) >=
          new Date(this.formData.stopJoinTime)
        ) {
          this.$message.error("不能大于等于停止参与时间");
          this.formData.enterEndTime = "";
        }
      }
    },
    handlereFinishEndTimeTime(val) {
      if (!!this.formData.stopJoinTime) {
        if (
          new Date(this.formData.reFinishEndTime) >=
          new Date(this.formData.stopJoinTime)
        ) {
          this.$message.error("不能大于等于停止参与时间");
          this.formData.reFinishEndTime = "";
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.item-wrap {
  margin-top: 10px;
  display: flex;
  align-items: center;
}
.createSemdReBuy {
  min-width: 800px;
  position: relative;
  box-sizing: border-box;
  height: 100%;
  background-color: #fff;
  border-radius: 6px;
  // margin: -24px;
  margin-bottom: 24px;
  overflow-y: auto;
  .headReturn {
    box-sizing: border-box;
    padding-left: 30px;
    width: 100%;
    height: 50px;
    line-height: 49px;
    border-bottom: 1px solid #f3f3f3;
    span {
      color: #ccc;
      cursor: pointer;
    }
    .name {
      color: #333;
      cursor: default;
    }
  }
  .step {
    padding: 30px 24px 0;
    .bz {
      display: flex;
      justify-content: center;
      height: 18px;
      // border-bottom: 1px solid #f3f3f3;
    }
  }
  .firststep {
    min-height: 720px;
    box-sizing: border-box;
    padding: 35px 35px 0;
    .itemList {
      display: flex;
      .item {
        box-sizing: border-box;
        position: relative;
        color: #666;
        text-align: center;
        padding: 6px;
        &:hover {
          .border::before,
          .border::after {
            opacity: 1;
            transform: scale(1);
          }
        }
        .border {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          border-radius: 4px;
          &::before,
          &::after {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            content: "";
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.8s, transform 0.8s;
            border-radius: 4px;
          }
          &::before {
            border-top: 1px solid #7b61ff;
            border-bottom: 1px solid #7b61ff;
            -webkit-transform: scale(0, 1);
            transform: scale(0, 1);
          }
          &::after {
            border-right: 1px solid #7b61ff;
            border-left: 1px solid #7b61ff;
            -webkit-transform: scale(1, 0);
            transform: scale(1, 0);
          }
        }
        .wrapper {
          position: relative;
          height: 350px;
          border-radius: 6px;
          overflow: hidden;
          width: 206px;
          &:hover {
            .mask {
              opacity: 1;
            }
          }
          .mask {
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.6);
            color: #fff;
            opacity: 0;
            transition: all 0.2s;
            .img {
              max-width: 130px;
              margin: 0 auto 30px;
              .imgBg {
                box-sizing: border-box;
                height: 129px;
                width: 129px;
                padding: 6px;
                border-radius: 6px;
                background-color: #fff;
              }
              .tpl {
                display: inline-block;
                margin-top: 4px;
                opacity: 0.7;
              }
            }
          }
        }
      }
    }
  }
  .secondstep {
    box-sizing: border-box;
    position: relative;
    padding: 0px 28px 1px 24px;
    margin-bottom: 29px;
    height: calc(100% - 130px);
    .zd {
      width: 360px;
    }
    .time2 {
      width: 54px;
      height: 28px;
      border-radius: 4px;
      display: inline-block;
      text-align: center;
      line-height: 28px;
    }
    .lastTime {
      margin-left: 20px;
      font-size: 14px;
      i {
        color: #ccc;
      }
    }
    .limit {
      display: flex;
      flex-direction: column;
      p {
        margin: 0;
        &:nth-child(2) {
          margin: 16px 0;
        }
      }
      .c {
        color: #7b61ff;
      }
      .desc {
        i {
          opacity: 0.7;
          color: #7b61ff;
        }
        color: #999;
      }
      /deep/ .el-input {
        margin: 0 6px;
      }
    }
    .img {
      display: inline-block;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: #eeeeee;
    }
    .tips {
      display: flex;
      flex-direction: column;
      margin-top: 16px;
      box-sizing: border-box;
      padding: 13px 30px;
      background: #fffaee;
      font-size: 13px;
      color: #333;
      i {
        color: #fe8f8a;
        opacity: 0.7;
      }
      p {
        margin: 0;
        line-height: 20px;
        padding-left: 18px;
      }
    }
    .generate {
      width: 76px;
      margin-top: 8px;
      background: rgba(127, 133, 233, 0.1);
      border: 1px solid rgba(127, 133, 233, 1);
      color: #7f85e9;
    }
    .termAdd {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 6px;
      color: #333;
      p {
        margin: 0;
      }
      .add {
        margin-left: 4px;
        color: #7b61ff;
      }
    }
    .set {
      display: inline-block;
      margin-top: 30px;
    }
    .desc {
      margin-left: 20px;
      color: #999;
      font-size: 13px;
      i {
        color: #fe8f8a;
        opacity: 0.7;
        font-size: 13px;
      }
    }
    .s {
      color: #7b61ff;
      cursor: pointer;
    }
    .returnBtn {
      width: 148px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid #7b61ff;
      color: #7b61ff;
      transition: all 0.2s;
      &:hover {
        background-color: #7b61ff;
        color: #fff;
      }
    }
    .keepBtn {
      margin-left: 30px;
      width: 188px;
      background-color: #7b61ff;
      color: #fff;
      transition: all 0.2s;
      &:hover {
        opacity: 0.9;
      }
    }
    .red {
      color: red;
      margin-left: 10px;
    }
    .createRlueBtn {
      border-radius: 4px;
      width: auto;
      height: 32px;
      line-height: 32px;
      text-align: center;
      color: #7b61ff;
      background: #f2efff;
      border: 1px solid #7b61ff;
      &:hover {
        color: #fff;
        background: #7b61ff;
      }
    }
    .createRlueTip {
      color: #aaaaaa;
      font-size: 13px;
      margin-left: 12px;
    }
    .generate {
      width: 76px;
      margin: 8px 8px 0 0;
      background: rgba(127, 133, 233, 0.1);
      border: 1px solid rgba(127, 133, 233, 1);
      color: #7f85e9;
    }
  }
}
.wrapper-kaika {
  width: 100%;
  height: 100%;
  display: grid;
  // align-items: center;
  // justify-content: center;

  .wrapper-kaika-img {
    background-color: #fafafa;
    border: 2px solid rgba(254, 77, 69, 0.0784313725490196);
    border-radius: 8px;
    height: 350px;
    // margin-right: 20px;
    position: relative;
    &:hover {
      .borderkaika::before,
      .borderkaika::after {
        opacity: 1;
        transform: scale(1);
      }
    }
    .borderkaika {
      position: absolute;
      left: -6px;
      top: -6px;
      width: 218px;
      height: 360px;
      border-radius: 4px;
      &::before,
      &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        content: "";
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.8s, transform 0.8s;
        border-radius: 4px;
      }
      &::before {
        border-top: 1px solid #7b61ff;
        border-bottom: 1px solid #7b61ff;
        -webkit-transform: scale(0, 1);
        transform: scale(0, 1);
      }
      &::after {
        border-right: 1px solid #7b61ff;
        border-left: 1px solid #7b61ff;
        -webkit-transform: scale(1, 0);
        transform: scale(1, 0);
      }
    }

    div {
      font-size: 18px;
      font-weight: bold;
      // line-height: 25px;
      color: #333333;
    }
    img {
      width: 32px;
      height: 32px;
    }

    .queryIdIMG {
      display: none;
    }
    &:hover {
      .queryIdIMG {
        display: block;
      }
      .mask {
        opacity: 1;
      }
    }
    .mask {
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.6);
      color: #fff;
      opacity: 0;
      transition: all 0.2s;
      .img {
        max-width: 130px;
        margin: 0 auto 30px;
        .imgBg {
          box-sizing: border-box;
          height: 129px;
          width: 129px;
          padding: 6px;
          border-radius: 6px;
          background-color: #fff;
        }
        .tpl {
          display: inline-block;
          font-size: 14px;
          color: #fff;
          margin-top: 10px;
          // opacity: 0.7;
        }
      }
    }
  }
  .wrapper-kaika-tanchuang {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .lijijq {
    &::after {
      content: "立即领取";
      display: block;
      position: absolute;
      bottom: 9px;
      left: 51%;
      transform: translateX(-50%);
      font-size: 14px;
      // font-family: system-ui;
      font-family: PingFang SC;
      font-weight: bold;
      color: #ed6e09;
      text-shadow: 0 0 black;
    }
  }
}
.miniAppPic {
  position: relative;
  .image-slot {
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    text-align: center;
    padding-top: 43px;
    i {
      font-size: 30px;
      color: #909399;
    }
  }
  .top {
    position: relative;
    left: 0px;
    display: flex;
    .returnBtn {
      border-radius: 4px;
      width: auto;
      height: 32px;
      line-height: 32px;
      text-align: center;
      color: #7b61ff;
      background: rgba(123, 97, 255, 0.1);
      border: 1px solid #7b61ff;
      &:hover {
        color: #fff;
        background: #7b61ff;
      }
    }
    .reset {
      // color: #7b61ff;
      cursor: pointer;
      font-size: 14px;
      margin-left: 15px;
    }
  }
  .bottom {
    position: relative;
    top: 15px;
    .elImg {
      width: 120px;
      height: 120px;
      border: 1px dashed #dddddd;
      border-radius: 5px;
    }
    .tips1 {
      position: absolute;
      left: 135px;
      top: 22px;
      line-height: 2;
      color: #aaaaaa;
      font-size: 13px;
    }
  }
}
.tishi {
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  color: #333333;
  background: #fffaee;
  border-radius: 4px;
  margin-bottom: 20px;
  padding: 14px 20px;
}

/deep/ .el-table__header-wrapper .el-checkbox {
  display: none;
}

/deep/ .createSemdReBuy {
  .textarea {
    .el-textarea__inner {
      min-height: 120px !important;
    }
  }
  .el-step__main {
    position: absolute;
    top: -7px;
    left: 33px;
  }
  .el-step__head.is-process {
    position: absolute;
  }
  .el-step.is-horizontal .el-step__line {
    left: 107px;
    right: 15px;
  }
  .el-step {
    position: relative;
  }
}
.remark-tip {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; //设置超出几行省略内容
  text-overflow: ellipsis;
  overflow: hidden;
}
.question-style {
  margin-left: 4px;
  color: #666;
  cursor: pointer;
}
.question-style1 {
  color: #666;
  cursor: pointer;
}
.icon-style {
  margin-left: 4px;
}
</style>
